export default {
    bulError: false,
    bulCorrecto: false,
    bulInfo: false,
    bulModal: true,
    language: 'esp',
    mensaje: "",
    isOpenManagmentData: false,
    errorAnInputRequired: false,
    eventSubmit: false,
    loader: false,
    headerProfile: {
        message: '',
        ancho: '',
        alto: '',
        izquierda: '',
        arriba: '',
        url: '',
        nombre: '',
        apellido: '',
        confirmacion: false,
        Id_usuario: 0
    },
    notifications: [],
    users: [],
    currencies: [],
    currenciesFiltered: [],
    currencySelected: {},
    currencyFormat: [],
    limitCurrency: 0
}